import { NavigationMenu, AppLink } from "@shopify/app-bridge/actions";
import type { ClientApplication } from "@shopify/app-bridge";
import { APP_NAV_ITEMS, findActiveNavItemIndex } from "../config/app-navigation";

let navMenuInstance: ReturnType<typeof NavigationMenu.create> | null = null;
let appLinkInstances: ReturnType<typeof AppLink.create>[] = [];

/**
 * Register the NavigationMenu once per app session (singleton; avoids duplicate nav in React Strict Mode).
 */
export function ensureEmbeddedNavigationMenu(app: ClientApplication): void {
  if (navMenuInstance) {
    return;
  }

  appLinkInstances = APP_NAV_ITEMS.map((item) =>
    AppLink.create(app, { label: item.label, destination: item.path })
  );

  const idx = findActiveNavItemIndex(
    typeof window !== "undefined" ? window.location.pathname : "/"
  );

  navMenuInstance = NavigationMenu.create(app, {
    items: appLinkInstances,
    active: appLinkInstances[idx],
  });
}

/** Update the highlighted item when the in-app route changes (e.g. React Router navigation). */
export function syncEmbeddedNavigationActive(pathname: string): void {
  if (!navMenuInstance || appLinkInstances.length === 0) {
    return;
  }
  const idx = findActiveNavItemIndex(pathname);
  navMenuInstance.set({ active: appLinkInstances[idx] });
}
